module.exports = "<div class=\"comment-cnt-item\">\r\n    <div class=\"comment-cnt-item-tit\">\r\n        <span class=\"name\">${name}</span> 回复 ：\r\n    </div>\r\n    <p class=\"comment-cnt-item-para\">${replyTxt}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/module/pannel-comment/comment.tpl
// module id = 198
// module chunks = 17 20